import React from 'react';
import { Paper, Grid, makeStyles, colors } from '@material-ui/core';
import ContentLoader from 'react-content-loader';

const useStyles = makeStyles({
  root: {
    height: '100%',
    width: '100%',
    padding: 16,
    borderRadius: '8px',
  },
  body: {
    padding: 16,
  },
  image: {
    height: 160,
    width: '100%',
    borderRadius: '8px',
    boxShadow: '0px 0px 16px -8px rgba(0,0,0,0.64)',
  },
});

const BigRecipeCardLoading = () => {
  const classes = useStyles();

  return (
    <Paper className={classes.root} elevation={3}>
      <Grid container direction="column" style={{ height: '100%' }}>
        <Grid item container>
          <RecipeImage></RecipeImage>
        </Grid>

        <Grid
          item
          container
          direction="column"
          spacing={1}
          style={{ flexGrow: 1, marginTop: 16 }}
        >
          <Grid item container>
            <RecipeTitle></RecipeTitle>
          </Grid>

          <Grid item container>
            <RecipeDescription></RecipeDescription>
          </Grid>

          <div style={{ flexGrow: 1 }}></div>

          <Grid item container>
            <RecipeTags></RecipeTags>
          </Grid>
        </Grid>
      </Grid>
    </Paper>
  );
};

const RecipeTitle = () => {
  return (
    <ContentLoader
      speed={2}
      height={16}
      backgroundColor={colors.grey[300]}
      foregroundColor={colors.grey[400]}
      style={{ width: '50%' }}
    >
      <rect x="0" y="0" height="16" style={{ width: '100%' }} />
    </ContentLoader>
  );
};

const RecipeDescription = () => {
  return (
    <ContentLoader
      speed={2}
      height={100}
      backgroundColor={colors.grey[300]}
      foregroundColor={colors.grey[400]}
      style={{ width: '100%' }}
    >
      <rect x="0" y="16" height="8" style={{ width: '100%' }} />
      <rect x="0" y="32" height="8" style={{ width: '100%' }} />
      <rect x="0" y="48" height="8" style={{ width: '100%' }} />
    </ContentLoader>
  );
};

const RecipeTags = () => {
  return (
    <Grid container spacing={2} alignItems="flex-end">
      <Grid item>
        <Tag></Tag>
      </Grid>

      <Grid item>
        <Tag></Tag>
      </Grid>
    </Grid>
  );
};
const Tag = () => {
  return (
    <ContentLoader
      speed={2}
      height={24}
      width={60}
      viewBox="0 0 60 24"
      backgroundColor={colors.grey[300]}
      foregroundColor={colors.grey[400]}
    >
      <rect x="0" y="0" height="24" width="60" />
    </ContentLoader>
  );
};

const RecipeImage = () => {
  return (
    <ContentLoader
      speed={2}
      height={160}
      backgroundColor={colors.grey[300]}
      foregroundColor={colors.grey[400]}
      style={{ width: '100%', height: 160 }}
    >
      <rect x="0" y="0" height="160" style={{ width: '100%' }} />
    </ContentLoader>
  );
};

export default BigRecipeCardLoading;
